/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-05 17:07:37
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-02-18 16:47:16
 * @Description: file content
 */
import * as types from "./mutation-types"; // 从mutation-types中拿到定义的常量

// mutations可以看做一个对象，里面有一些方法
// 通俗的理解mutations,里面装着一些改变数据方法的集合，这是Veux设计很重要的一点，就是把处理数据逻辑方法全部放在mutations里面，使得数据和视图分离。
// 里面这些方法的名字为：types.SET_SINGER等。。。
const mutations = {
  // 下面是types.SET_SINGER方法，有两个参数，一个参数state是当前的状态，第二个是提交mutations时传的参数
  [types.SET_INFO](state, info) {
    state.info = info;
  },
  [types.SET_CHANNEL](state, channel) {
    state.channel = channel;
    console.log("state.channel>>>", channel)
  },
  [types.SET_ADDLIST](state, addList) {
    state.addList.unshift(addList);
    console.log("state.addList>>>", addList)
  },
  [types.SET_ISSHOWGUIDE](state, isShowGuide) {
    state.isShowGuide = isShowGuide;
    console.log("state.isShowGuide>>>", isShowGuide)
  },
  [types.SET_ISLOADING](state, isLoading) {
    state.isLoading = isLoading;
    console.log("state.isLoading>>>", isLoading)
  },
  [types.SET_ISINMINIPROGRAM](state, isInMiniProgram) {
    state.isInMiniProgram = isInMiniProgram;
    console.log("state.isInMiniProgram>>>", isInMiniProgram)
  },
  [types.SET_RECEIVESPREADINFO](state, receiveSpreadInfo) {
    state.receiveSpreadInfo = receiveSpreadInfo;
    console.log("state.receiveSpreadInfo>>>", JSON.parse(JSON.stringify(receiveSpreadInfo)));
  },
  [types.SET_SHARESPREADINFO](state, shareSpreadInfo) {
    state.shareSpreadInfo = shareSpreadInfo;
    console.log("state.shareSpreadInfo>>>", JSON.parse(JSON.stringify(shareSpreadInfo)));
  },
  [types.SET_PAGEINFO](state, pageInfo) {
    // 如果是t数字 类型的
    if (/\/t\d/.test(location.href)) {
      window.document.title = pageInfo.BrowserTabTitle;
    }
    state.pageInfo = pageInfo;
    console.log("state.pageInfo>>>", JSON.parse(JSON.stringify(pageInfo)))
  },
  [types.SET_CARDINFO](state, cardInfo) {
    if (location.href.indexOf("vcard") > -1) {
      if (cardInfo && cardInfo.Ui && cardInfo.Ui.Name)
        window.document.title = cardInfo.Ui.Name + "的智能名片";
    }
    state.cardInfo = cardInfo;
    console.log("state.cardInfo>>>", JSON.parse(JSON.stringify(cardInfo)));
  },
  [types.SET_USERINFO](state, userInfo) {
    state.userInfo = userInfo;
    console.log("state.userInfo>>>", JSON.parse(JSON.stringify(userInfo)))
  },
  [types.SET_HDKUSERINFO](state, hdkUserInfo) {
    state.hdkUserInfo = hdkUserInfo;
    console.log("state.hdkUserInfo>>>", JSON.parse(JSON.stringify(hdkUserInfo)))
  },
  [types.SET_SOURCEGZHINFO](state, sourceGzhInfo) {
    state.sourceGzhInfo = sourceGzhInfo;
    console.log("state.sourceGzhInfo>>>", JSON.parse(JSON.stringify(sourceGzhInfo)));
  },
  [types.SET_ISSHOWMYCARD](state, isShowMyCard) {
    state.isShowMyCard = isShowMyCard;
    console.log("state.isShowMyCard>>>", JSON.parse(JSON.stringify(isShowMyCard)));
  },
  [types.SET_RSCARDINFO](state, rsCardInfo) {
    state.rsCardInfo = rsCardInfo;
    console.log("state.rsCardInfo>>>", JSON.parse(JSON.stringify(rsCardInfo)));
  }

};

export default mutations;
